"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATE_FORMAT_YYYY_MM_DDTHH_mm_ssZ = exports.DATE_FORMAT_HH_mm = exports.DATE_FORMAT_DD_MM_YYYY_HH_mm = exports.DATE_FORMAT_DD_MM_YYYY_HH_mm_ss_sz = exports.DATE_FORMAT_DD_MM_YYYY_HH_mm_ss = exports.DATE_FORMAT_DD_MM_YYYY_COMBINED = exports.DATE_FORMAT_dd_MMM_YYYY = exports.DATE_FORMAT_dd_MM_yy = exports.DATE_FORMAT_dd_MMM = exports.DATE_FORMAT_DD_MM_YYYY_WITH_SLASH = exports.DATE_FORMAT_m_d_YYYY_WITH_SLASH = exports.DATE_FORMAT_mm_dd_YYYY_WITH_SLASH = exports.DATE_FORMAT_DD_MM_YYYY_WITH_DOT = exports.DATE_FORMAT_DD_MM_YYYY = exports.DATE_FORMAT_YYYY_MM_dd_HH_mm = exports.DATE_FORMAT_YYYY_MM_dd_Combined = exports.DATE_FORMAT_YYYY_MM_dd = exports.DATE_FORMAT_YYYYMMdd = void 0;
var DATE_FORMAT_YYYYMMdd = "YYYYMMdd";
exports.DATE_FORMAT_YYYYMMdd = DATE_FORMAT_YYYYMMdd;
var DATE_FORMAT_YYYY_MM_dd = "YYYY-MM-dd";
exports.DATE_FORMAT_YYYY_MM_dd = DATE_FORMAT_YYYY_MM_dd;
var DATE_FORMAT_YYYY_MM_dd_Combined = "YYYYMMddHHmm";
exports.DATE_FORMAT_YYYY_MM_dd_Combined = DATE_FORMAT_YYYY_MM_dd_Combined;
var DATE_FORMAT_YYYY_MM_dd_HH_mm = "YYYY-MM-dd HH:mm";
exports.DATE_FORMAT_YYYY_MM_dd_HH_mm = DATE_FORMAT_YYYY_MM_dd_HH_mm;
var DATE_FORMAT_DD_MM_YYYY = "DD-MM-YYYY";
exports.DATE_FORMAT_DD_MM_YYYY = DATE_FORMAT_DD_MM_YYYY;
var DATE_FORMAT_DD_MM_YYYY_WITH_DOT = "DD.MM.YYYY";
exports.DATE_FORMAT_DD_MM_YYYY_WITH_DOT = DATE_FORMAT_DD_MM_YYYY_WITH_DOT;
var DATE_FORMAT_mm_dd_YYYY_WITH_SLASH = "MM/dd/YYYY";
exports.DATE_FORMAT_mm_dd_YYYY_WITH_SLASH = DATE_FORMAT_mm_dd_YYYY_WITH_SLASH;
var DATE_FORMAT_m_d_YYYY_WITH_SLASH = "M/d/YYYY";
exports.DATE_FORMAT_m_d_YYYY_WITH_SLASH = DATE_FORMAT_m_d_YYYY_WITH_SLASH;
var DATE_FORMAT_DD_MM_YYYY_WITH_SLASH = "DD/MM/YYYY";
exports.DATE_FORMAT_DD_MM_YYYY_WITH_SLASH = DATE_FORMAT_DD_MM_YYYY_WITH_SLASH;
var DATE_FORMAT_dd_MMM = "ddMMM";
exports.DATE_FORMAT_dd_MMM = DATE_FORMAT_dd_MMM;
var DATE_FORMAT_dd_MM_yy = "ddMMyy";
exports.DATE_FORMAT_dd_MM_yy = DATE_FORMAT_dd_MM_yy;
var DATE_FORMAT_dd_MMM_YYYY = "ddMMMYYYY";
exports.DATE_FORMAT_dd_MMM_YYYY = DATE_FORMAT_dd_MMM_YYYY;
var DATE_FORMAT_DD_MM_YYYY_COMBINED = "DDMMYYYY";
exports.DATE_FORMAT_DD_MM_YYYY_COMBINED = DATE_FORMAT_DD_MM_YYYY_COMBINED;
var DATE_FORMAT_DD_MM_YYYY_HH_mm_ss = "YYYY-MM-dd'T'HH:mm:ss";
exports.DATE_FORMAT_DD_MM_YYYY_HH_mm_ss = DATE_FORMAT_DD_MM_YYYY_HH_mm_ss;
var DATE_FORMAT_DD_MM_YYYY_HH_mm_ss_sz = "YYYY-MM-dd'T'HH:mm:ss.SSS";
exports.DATE_FORMAT_DD_MM_YYYY_HH_mm_ss_sz = DATE_FORMAT_DD_MM_YYYY_HH_mm_ss_sz;
var DATE_FORMAT_DD_MM_YYYY_HH_mm = "dd-MM-YYYY HH:mm";
exports.DATE_FORMAT_DD_MM_YYYY_HH_mm = DATE_FORMAT_DD_MM_YYYY_HH_mm;
var DATE_FORMAT_HH_mm = "HH:mm";
exports.DATE_FORMAT_HH_mm = DATE_FORMAT_HH_mm;
var DATE_FORMAT_YYYY_MM_DDTHH_mm_ssZ = "YYYY-MM-DD'T'HH:mm:ssZ";
exports.DATE_FORMAT_YYYY_MM_DDTHH_mm_ssZ = DATE_FORMAT_YYYY_MM_DDTHH_mm_ssZ;